import React, {useState, useEffect, Children} from "react";
import {EmployeeTeamVM} from '../../Models/ViewModels';
import {Table, Pagination, Stack, Avatar, Input, Button, Dropdown, Toggle} from "rsuite";
import * as TeamDB from '../../Services/EmployeeDB';
import {PageHeader} from "../../SharedComponents/PageHeader";
import * as XLSX from 'xlsx'
import { handleDownloadAsExcel } from "../../Helpers/Utils";
import {TeamCard} from "./TeamCard";
import * as _ from 'lodash';
import {SingleStat} from "../Home/SingleStat";
import { GetUserLoginID } from "../../Services/UserSessionManager";
import { BootstrapIcon } from "../../SharedComponents/BootstrapIcon";

const {Column, HeaderCell, Cell} = Table;
const colors = ['pink', 'grey', 'blue', 'yellow', 'purple', 'green', 'red'];

export const TeamDetailSimple = ({name, designation, department}: any) => {

    const [cachedTeamList, setCachedTeamList] = useState(new Array<EmployeeTeamVM>())
    const [sortColumn, setSortColumn] = useState();
    const [sortType, setSortType] = useState();
    const [loading, setLoading] = useState(false);


    const [page, setPage] = React.useState(1);
    const [limit, setLimit] = React.useState(10);
    const [filteredTeamList, setFilteredTeamList] = useState(new Array<EmployeeTeamVM>());
    const[loginid,setLoginid]=useState(GetUserLoginID())
    useEffect(() => {
        getAllTeamList(loginid);
    }, [])


    const filterData = (val: string, e: any) => {
        let searchText = val;
        if (searchText)
            setFilteredTeamList(cachedTeamList.filter(e => JSON.stringify(e).toLowerCase().includes(searchText.toLowerCase())))
        else
            setFilteredTeamList([...cachedTeamList]);
    }
    

    const tableDataFeed = filteredTeamList.filter((v, i) => {
        const start = limit * (page - 1);
        const end = start + limit;
        return i >= start && i < end;
    });

    const filterTeams = (e: any) => {
        let val = e.target.value;
        setFilteredTeamList(cachedTeamList.filter(x =>JSON.stringify(x).toLowerCase().includes(val.toLowerCase())))
    }

    const sortListBy = (colName:string)=>{
      
        setFilteredTeamList(_.orderBy(filteredTeamList,[colName]));
    }

    const handleChangeLimit = (dataKey: any) => {
        setPage(1);
        setLimit(dataKey);
    };

   
    const getAllTeamList = (loginid:any) => {
        TeamDB.GetTeamDetails(loginid).then(res => {
            if (res.data) {
               
                setCachedTeamList(res.data)
                setFilteredTeamList(res.data);
            }
        }).catch(err => {
            console.log("fail")
        })
    }

    const SortByDropdown = (
        <select className="form-select" aria-label="Sort By" onChange={e=>sortListBy(e.target.value)}>
            <option value="Team">Team name</option>
            <option value="Processes">Head Count</option>
            {/* <option value="bufferper">Buffer</option>
            <option value="allper">Allocation</option> */}
        </select>
 
    );

    const AscDscToggle = (
        <div>
            <Toggle size="lg" checkedChildren="Dsc" unCheckedChildren="Asc"/>
        </div>
    );

    return <>
        <div className="d-flex gap-4">
            <div className="flex-grow-1">
                <input className="form-control w-50" type="search" autoFocus={true} placeholder={"Search team...."}
                       onChange={filterTeams}/>
            </div>
            <div>
                <div className="d-flex flex-row align-items-center justify-content-between gap-1 fs-1 border rounded px-2 py-1">
                    <div>Total</div>
                    <div><b>{filteredTeamList.length}</b></div>
                </div>
            </div>
            <div >
  
  {/* <button id="color" onClick={() => handleDownloadAsExcel(filteredTeamList)}><BootstrapIcon bootStrapIconName={"file-earmark-arrow-down-fill"} size={30} cssClasses={'pe-2'} />   </button>  */}
     
           </div>
           
        </div>

        {filteredTeamList.map((t: any) => {
              var count:number=0;
            t.Processes.map((p:any)=>{
              
                count=count+p.ProcessCount;
            })
            return <TeamCard department={t.Team} headCount={count} processes={t.Processes}/>
        })}
    </>
}
